import { forwardRef } from "react";
import { bfPublicUrl, campRule, fmtDate, logo } from "@/lib/bf";

const BFStoryCard = forwardRef(({ cfg, brand }, ref) => {
  const camps = cfg.campaigns.filter((c) => c.active && (!brand || c.brand === brand));
  const items = [...camps].sort((a, b) => b.discount - a.discount).slice(0, 4);
  const max = Math.max(0, ...camps.map((c) => c.discount));
  const brands = cfg.brands;
  const name = (id) => cfg.brands.find((b) => b.id === id)?.name;
  return (
    <div ref={ref} className="bfs" data-testid="bf-story-card">
      <div className="bfs-glow" />
      <span className="bfs-kicker">Beauty Trends · ofertă pentru saloane</span>
      <h1>{cfg.title}</h1>
      <p className="bfs-sub">{cfg.subtitle}</p>
      <p className="bfs-top">Branduri profesionale de top</p>
      {brand ? <img className="bfs-logo" src={logo(brand)} alt="" /> : (
        <div className="bfs-logos">{brands.map((b) => <img key={b.id} src={logo(b.id)} alt="" />)}</div>
      )}
      {max > 0 && <div className="bfs-max">până la <b>-{max}%</b></div>}
      <div className="bfs-grid">
        {items.map((c) => (
          <div key={c.id} className="bfs-camp">
            <small>{name(c.brand)}</small>
            <b>{c.name}</b>
            <div className="bfs-camp-d">{`-${c.discount}%`}</div>
            <span>{campRule(c, Object.fromEntries(cfg.products.map((p) => [p.id, p])))}{c.gift ? ` + ${c.gift}` : ""}</span>
          </div>
        ))}
      </div>
      <div className="bfs-foot">
        <b>{fmtDate(cfg.start)} – {fmtDate(cfg.end)}</b>
        <span>{bfPublicUrl().replace(/^https?:\/\//, "")}{cfg.whatsapp ? ` · ${cfg.whatsapp}` : ""}</span>
        <small>Prețuri salon, cu TVA inclus</small>
      </div>
    </div>
  );
});

export default BFStoryCard;
